import { useCallback, useEffect } from 'react';
import { getUrnByViewerUrn } from '../models/modelManagement';
export function useViewManagement({
  geometryLoaded,
  viewer,
  focusOnElements
}) {
  const focusOnModelElements = useCallback(params => {
    const {
      geometryLoaded,
      focusOnElements,
      viewer
    } = params;
    const loadedFocus = Object.entries(focusOnElements).filter(([urn]) => geometryLoaded[urn]);

    if (!loadedFocus.length || loadedFocus.length > 1) {
      // В типах не описан метод goHome, но в доке он есть
      // https://forge.autodesk.com/en/docs/viewer/v7/reference/Viewing/ViewingUtilities/#gohome
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      viewer.utilities.goHome();
      return;
    }

    loadedFocus.forEach(([urn, externalIds]) => {
      const model = viewer.getVisibleModels().find(model => getUrnByViewerUrn(model.getData().urn) === urn);

      if (!geometryLoaded[urn] || !model) {
        return;
      }

      const objectIds = externalIds.map(extId => geometryLoaded[urn][extId]).filter(extId => !!extId);

      if (objectIds.length) {
        viewer.fitToView(objectIds, model);
      } else {
        viewer.fitToView();
      }
    });
  }, []);
  useEffect(() => {
    if (viewer && focusOnElements && geometryLoaded) {
      focusOnModelElements({
        viewer: viewer,
        geometryLoaded,
        focusOnElements
      });
    }
  }, [focusOnElements, geometryLoaded, viewer, focusOnModelElements]);
}